import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { KNOWLEDGE_BASE, KnowledgeBaseEntry } from './knowledge-base';

@Component({
  selector: 'app-knowledge-base',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './knowledge-base.component.html',
  styleUrl: './knowledge-base.component.scss'
})
export class KnowledgeBaseComponent {
  open = false;
  search = '';
  readonly entries = KNOWLEDGE_BASE;

  toggle(): void {
    this.open = !this.open;
  }

  close(): void {
    this.open = false;
  }

  get filteredGroups(): { category: string; entries: KnowledgeBaseEntry[] }[] {
    const term = this.search.trim().toLowerCase();
    const filtered = term
      ? this.entries.filter(e =>
          e.label.toLowerCase().includes(term) ||
          e.description.toLowerCase().includes(term) ||
          e.key.toLowerCase().includes(term))
      : this.entries;

    const byCategory = new Map<string, KnowledgeBaseEntry[]>();
    for (const entry of filtered) {
      const cat = entry.category || 'Other';
      if (!byCategory.has(cat)) byCategory.set(cat, []);
      byCategory.get(cat)!.push(entry);
    }
    return Array.from(byCategory.entries()).map(([category, entries]) => ({ category, entries }));
  }
}